import React, { lazy } from 'react';
export function Footer() {
  return <footer className="bg-plum-dark text-cream/60 py-12 md:py-16 px-5 md:px-6 border-t border-gold/20" data-id="element-83">
      <div className="max-w-6xl mx-auto flex flex-col text-center mt-[-90px] mb-[-90px] items-center justify-start" data-id="element-84">
        {/* Brand logo */}
        <div className="mb-6 md:mb-8" data-id="element-85">
          <img src="https://cdn.magicpatterns.com/uploads/k6NGZLTawqY3196KDYTKkN/logo_sin_fondo.png" alt="Mujer Expansiva" width="220" height="110" loading="lazy" decoding="async" className="w-40 md:w-52 h-auto mx-auto mt-[-60px] mb-[-60px]" style={{
          filter: 'brightness(0) invert(1) opacity(0.95)'
        }} data-id="element-86" />
        </div>

        {/* Gold hairline divider */}
        <div className="w-12 h-px bg-gold mb-6 md:mb-8" data-id="element-87" />

        <p className="max-w-md mx-auto mb-6 md:mb-8 text-xs md:text-sm leading-relaxed font-light" data-id="element-88">
          El sistema para mujeres que saben que valen más — y están listas para
          que su cuenta bancaria lo refleje.
          <br data-id="element-89" />
          <br data-id="element-90" />
          <span className="italic text-gold/80" data-id="element-91">
            Tu habilidad ya existe. Tu prosperidad también puede existir.
          </span>
        </p>

        <div className="flex flex-col md:flex-row justify-center gap-2 md:gap-4 text-xs md:text-sm mb-8 md:mb-10" data-id="element-92">
          <a href="mailto:expansivamujer@gmail.com" className="hover:text-gold transition-colors" data-id="element-93">
            expansivamujer@gmail.com
          </a>
          <span className="hidden md:inline text-gold/40" data-id="element-94">·</span>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-95">
            @guadaquenan
          </a>
          <span className="hidden md:inline text-gold/40" data-id="element-96">·</span>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-97">
            guadaquenan.online
          </a>
        </div>

        <p className="text-[10px] md:text-xs uppercase tracking-[0.25em] text-gold/50" data-id="element-98">
          © Mujer Expansiva™ 2026 — Todos los derechos reservados
        </p>
      </div>
    </footer>;
}